import React from 'react';
import EmailVerificationPanel from './EmailVerificationPanel';
import { MobilePageRoot } from './EmailVerificationPanel.styled';

const MobileVerificationPage = ({ email, onVerify }) => {
    return (
        <MobilePageRoot data-testid="MobileOTP-container">
            <EmailVerificationPanel
                email={email}
                onVerified={onVerify}
                constrainCodeFieldWidth={false}
            />
        </MobilePageRoot>
    );
};

export default MobileVerificationPage;
